import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import Confirm from 'react-confirm-bootstrap';
import * as actions from '../../actionTypes'
import Pagination from "react-js-pagination"
import Loader from '../Loader'
import AuditTrail from '../AuditTrail'
import * as constants from '../../Constatnts'

class ProductTagList extends Component {
    constructor() {
        super()
        this.state = {
            tags: [],
            selectedTag: '',
            searchActiveInactiveAllRecords: 'active',
            paginationStatus: 'No records to display',            
            activePage: 1,
            itemsCountPerPage: 20,
            totalItemsCount: 0,
            recordFrom: 0,
            searchText:'',
            loading: true
        }
        this.loadProductTags = this.loadProductTags.bind(this)
        this.onDeleteProductTag = this.onDeleteProductTag.bind(this)           
        this.onClearSearch = this.onClearSearch.bind(this)
        this.onSearchActiveInactiveAllRecordsClicked = this.onSearchActiveInactiveAllRecordsClicked.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.showPaginationStatus = this.showPaginationStatus.bind(this)
    }
    componentDidMount() {
        console.log('Called');
        this.loadProductTags(this.state.recordFrom,
                this.state.searchActiveInactiveAllRecords,
                this.state.searchText)
    }

    loadProductTags(from,option,searchText) {
        this.setState({ loading: true })
        this.props.searchProductTags(this.props.user.user.RegistrationID, from, this.state.itemsCountPerPage, option, searchText).then((result) => {
             this.setState({ tags: result.searchResult, totalItemsCount: result.totalItemsCount, loading: false })
            this.showPaginationStatus()
        })
    }

    onClearSearch()
    {
        this.setState({
            recordFrom:0, searchText: '', searchActiveInactiveAllRecords: 'active'
        })
        this.loadProductTags(0,"active", "")
    }

    onSearchActiveInactiveAllRecordsClicked(option)
    {
        this.setState({
            searchActiveInactiveAllRecords:option, recordFrom: 0
        })
        this.loadProductTags(0,option,this.state.searchText)
    }

    onSearchClick()
    {
        this.loadProductTags(this.state.recordFrom,
            this.state.searchActiveInactiveAllRecords,
            this.state.searchText)
    }

    handlePageChange(pageNumber) {
        let recordFrom = ((pageNumber - 1) * this.state.itemsCountPerPage)
        this.setState({ activePage: pageNumber, recordFrom: recordFrom });
        this.loadProductTags(recordFrom,
            this.state.searchActiveInactiveAllRecords,
            this.state.searchText,
            )
    }

    showPaginationStatus() {
        let paginationStatus
        if ((this.state.recordFrom + 1) === this.state.totalItemsCount) {
            paginationStatus = "Showing " + this.state.totalItemsCount + " of " + this.state.totalItemsCount
        }
        else if ((this.state.recordFrom + this.state.itemsCountPerPage + 1) > this.state.totalItemsCount) {
            paginationStatus = "Showing " + (this.state.recordFrom + 1) + " to  " + this.state.totalItemsCount + " of " + this.state.totalItemsCount
        }
        else {
            paginationStatus = "Showing " + (this.state.recordFrom + 1) + " to  " + (this.state.recordFrom + this.state.itemsCountPerPage) + " of " + this.state.totalItemsCount

        }
        this.setState({ paginationStatus: paginationStatus })
    }

    

    onDeleteProductTag(key) {
        this.props.deleteProductTag(key).then(()=> { 
            setTimeout(function () { //Start the timer
                this.props.getToastr("Tag deleted successfully")
                this.loadProductTags(this.state.recordFrom,
                    this.state.searchActiveInactiveAllRecords,
                    this.state.searchText)
            }.bind(this), 3000)
        })
    }

    render() {
        const btnColStyle = { width: "120px" }

        return <div className="content-wrapper" >
            <section className="content" >
                <div className="row">
                    <div className="col-md-12">
                        <div className="box ">
                            <div className="box-header with-border">
                                <div className="row">
                                    <div className="col-md-6">
                                        <font style={{ fontSize: "30px" }}>Product Groups</font>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="pull-right" style={{ marginTop: "6px" }}>
                                            <Link to="/home/catalogue/addtags" className="btn btn-success btn-flat  btn-md" >Add Product Groups</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                        <div className="btn-group">
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "active" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("active")}>Active</button>
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "inactive" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("inactive")}>In Active</button>
                                            <button type="button" className={this.state.searchActiveInactiveAllRecords === "all" ? "btn btn-primary btn-flat btn-md " : "btn btn-default btn-flat btn-md"}
                                                onClick={() => this.onSearchActiveInactiveAllRecordsClicked("all")}>All</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label>Search by Group name</label>
                                            <input type="text" className="form-control input-md"
                                                value={this.state.searchText}
                                                onChange={(evt) => this.setState({ searchText: evt.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <button type="button" className="btn btn-primary btn-flat btn-md pull-right"
                                            style={{ marginTop: "25px", marginLeft: "5px" }}
                                            onClick={this.onSearchClick}
                                        >Search</button>
                                        <button type="button" className="btn btn-default btn-flat btn-md pull-right" style={{ marginTop: "25px" }}
                                            onClick={this.onClearSearch} >Clear</button>
                                    </div>
                                </div>
                                {this.state.loading && <Loader show={this.state.loading} />}

                                {!this.state.loading &&
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Revision History</th>
                                            <th style={btnColStyle}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.tags.map((tag) =>
                                            <tr>
                                                <td>{tag.Name}</td>
                                                <td>{tag.Description}</td>
                                                <td>
                                                    <div>Action :{tag.Action}</div>
                                                    <div>Action By :{tag.ActionBy}</div>                                                        
                                                    <div>Action Date :{(new Date(tag.ActionOn)).toString().substring(0,24)}</div>
                                                    <AuditTrail {...this.props} module={constants.PRODUCT_TAG} parentKey={tag.key}/>
                                                </td>
                                                <td>
                                                    <div className="btn-group">
                                                        {tag.IsDeleted ? <span className="label label-danger pull-right">Inactive</span> :
                                                            <div>
                                                                <Link to={`/home/catalogue/tags/edit/${tag.key}`}
                                                                    type="button" className="btn btn-md btn-default "><i className="fa fa-edit"></i></Link>
                                                                <Confirm
                                                                    onConfirm={() => this.onDeleteProductTag(tag.key)}
                                                                    body="Are you sure you would like to delete this Tag?"
                                                                    confirmText="Delete"
                                                                    title="Delete Tag">
                                                                    <button className="btn btn-default"><i className="fa fa-trash-o"></i></button>
                                                                </Confirm>
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>}
                                {this.state.totalItemsCount > 0 && <div className="pull-left" style={{ marginTop: "25px" }}>
                                    {this.state.paginationStatus}
                                </div>}
                                <div className="pull-right">
                                    <Pagination
                                        activePage={this.state.activePage} //this.state.activePage
                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                        totalItemsCount={this.state.totalItemsCount}
                                        pageRangeDisplayed={2}
                                        onChange={this.handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    }
}

export default withRouter(ProductTagList)